import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const Terms = () => {
  return (
    <div className="terms-page">
      <Navbar />
      <section className="legal-page">
        <div className="container">
          <div className="legal-content">
            <h1>Terms and Conditions</h1>
            <p className="last-updated">Last Updated: March 23, 2026</p>
            
            <section>
              <h2>1. Agreement to Terms</h2>
              <p>
                By accessing or using the CodeRidge website and services, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you may not access our services.
              </p>
            </section>

            <section>
              <h2>2. Use License</h2>
              <p>
                Permission is granted to temporarily access the materials on CodeRidge's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
              </p>
              <ul>
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or for any public display</li>
                <li>Attempt to reverse engineer any software contained on the website</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
              </ul>
            </section>

            <section>
              <h2>3. Services</h2>
              <p>
                CodeRidge provides software and product engineering, intelligent automation and AI integration, cybersecurity and zero-trust advisory, Cloud 3.0 and hybrid infrastructure work, managed IT and operations support, web and mobile development, UI/UX, technology consulting, and EdTech products such as Kidsphere. Specific scope, fees, and SLAs are defined in separate statements of work or agreements where applicable. We reserve the right to modify, suspend, or discontinue any offering at any time without prior notice except as agreed in writing.
              </p>
            </section>

            <section>
              <h2>4. Intellectual Property</h2>
              <p>
                All content, features, and functionality of our services, including but not limited to text, graphics, logos, images, and software, are the exclusive property of CodeRidge and are protected by international copyright, trademark, and other intellectual property laws.
              </p>
            </section>

            <section>
              <h2>5. User Accounts</h2>
              <p>When you create an account with us, you must provide accurate and complete information. You are responsible for:</p>
              <ul>
                <li>Maintaining the security of your account</li>
                <li>All activities that occur under your account</li>
                <li>Notifying us immediately of any unauthorized use</li>
              </ul>
            </section>

            <section>
              <h2>6. Prohibited Uses</h2>
              <p>You may not use our services:</p>
              <ul>
                <li>In any way that violates any applicable law or regulation</li>
                <li>To transmit any malicious code or viruses</li>
                <li>To impersonate or attempt to impersonate the company</li>
                <li>In any way that infringes upon the rights of others</li>
                <li>To engage in any automated use of the system</li>
              </ul>
            </section>

            <section>
              <h2>7. Disclaimer</h2>
              <p>
                The materials on CodeRidge's website are provided on an 'as is' basis. CodeRidge makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
              </p>
            </section>

            <section>
              <h2>8. Limitations</h2>
              <p>
                In no event shall CodeRidge or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on CodeRidge's website.
              </p>
            </section>

            <section>
              <h2>9. Accuracy of Materials</h2>
              <p>
                The materials appearing on CodeRidge's website could include technical, typographical, or photographic errors. CodeRidge does not warrant that any of the materials on its website are accurate, complete, or current.
              </p>
            </section>

            <section>
              <h2>10. Links</h2>
              <p>
                CodeRidge has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by CodeRidge of the site.
              </p>
            </section>

            <section>
              <h2>11. Modifications</h2>
              <p>
                CodeRidge may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.
              </p>
            </section>

            <section>
              <h2>12. Governing Law</h2>
              <p>
                These terms and conditions are governed by and construed in accordance with the laws of India and you irrevocably submit to the exclusive jurisdiction of the courts in Hyderabad, India.
              </p>
            </section>

            <section>
              <h2>13. Contact Information</h2>
              <p>
                If you have any questions about these Terms and Conditions, please contact us at:
              </p>
              <p>
                <strong>Email:</strong> legal@coderidge.in<br />
                <strong>Address:</strong> Hyderabad, India
              </p>
            </section>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Terms;










